import React from 'react';
import appLogo from 'src/assets/images/app-logo.png';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { BaseTypography } from '../../components/common/BaseTypography/BaseTypography';
import bgImg from './bg.png';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { ContactUsFormContainer } from './ContactUsForm/ContactUsFormContainer';
import clsx from 'clsx';

const tcUrl = APP_ROUTES.TERMS_AND_CONDITIONS;
const ppUrl = APP_ROUTES.PRIVACY_POLICY;

const useStyles = makeStyles((theme) => ({
  root: {
    background: `url(${bgImg})`,
    padding: '20px 0',
    backgroundSize: 'cover',
  },
  body: {
    display: 'grid',
    gridTemplateColumns: 'max-content 730px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  block__logoSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      marginTop: '80px',
      order: '2',
    },
  },
  block__logo: {
    marginBottom: '56px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '15px',
    },
  },
  footIcon: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '5px'
  }, 
  truspilot:{
		margin: "20px 0"
	}
}));

export const ContactUsFooter: React.FC<any> = (props) => {
  const { className, ...otherProps } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const url = window.location.pathname;

  const footer = 
  url !== APP_ROUTES.SURVEY_FORM ? (
    <div className={clsx(classes.root, className)} {...otherProps}>
      <div className={commonClasses.container}>
		<div className={`${classes.truspilot} `} >
			<div 
			  className="trustpilot-widget"
			  data-locale="en-GB" 
			  data-template-id="5419b6a8b0d04a076446a9ad" 
			  data-businessunit-id="647f5da670edebc1c8cdd6e4" 
			  data-style-height="24px" 
			  data-style-width="100%" 
			  data-theme="light" 
			  data-min-review-count="10" 
			  data-without-reviews-preferred-string-id="1" 
			  data-style-alignment="left">
			  <a href="https://www.trustpilot.com/review/contactsbook.media">Trustpilot</a>
			</div>
		</div>
        <div className={classes.body}>
          <div className={classes.block__logoSection}>
            <div className={classes.block__logo}>
              <img src={appLogo} alt="ContactsBook Logo" />
            </div>

            <div className={classes.footIcon}>
			  <a aria-label="icon" href="https://www.linkedin.com/company/79170993/admin/"
				target="_blank"
				rel="noreferrer">
				<svg
				  xmlns="http://www.w3.org/2000/svg"
				  width="24"
				  height="24"
				  viewBox="0 0 24 24">
				  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
				</svg>
			  </a>
			  <a aria-label="icon" href="https://www.youtube.com/@ContactsBookAsia/videos"
			  target="_blank"
			  rel="noreferrer">
			  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">    <path d="M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z"/></svg>
			</a>
			</div>
            
            <div>
              <BaseTypography variant="text">
                Powered by Hong Bao Media
              </BaseTypography>
              <BaseTypography variant="text">
                ©2024 All rights reserved.
              </BaseTypography>
              <BaseTypography variant="text">
                138 Robinson Road #21-02 Oxley Tower Lobby 1, 068906 
              </BaseTypography>
			  <BaseTypography variant="text">
				<a href={tcUrl}>Terms and Conditions</a> | <a href={ppUrl}>Privacy Policy</a>
              </BaseTypography>
            </div>
          </div>

          <div>
            <ContactUsFormContainer isVerticalForm={isMobile} />
          </div>
        </div>
      </div>
    </div>
  ) : (
	<>
	</> 
  )
  return footer;
};
